module.exports = __webpack_public_path__ + "img/banner1.14f31bc6.jpg";